import { Box } from '@mui/material';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { COLORS } from '../../utils/Application_Constants';

const DataGridSortIcon = ({ direction }) => {
    if (!direction) {
        return (
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                <ArrowDropUpIcon
                    fontSize="medium"
                    sx={{ color: COLORS.LT_MIDNIGHT50, marginBottom: '-8px' }}
                />
                <ArrowDropDownIcon
                    fontSize="medium"
                    sx={{ color: COLORS.LT_MIDNIGHT50, marginTop: '-8px' }}
                />
            </Box>
        );
    }
    return direction === 'asc' ? (
        <ArrowDropUpIcon sx={{ color: COLORS.LT_MIDNIGHT50 }} />
    ) : (
        <ArrowDropDownIcon sx={{ color: COLORS.LT_MIDNIGHT50 }} />
    );
};

export default DataGridSortIcon;
